module.exports = __webpack_public_path__ + "static/media/charity-footer.56d5322f.png";